"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var forms_1 = require("@pbl/pbl-react-core/lib/models/forms");
var types_1 = require("@pbl/pbl-react-core/lib/models/profile/types");
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var DateFieldValidator_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/DateFieldValidator"));
var PhoneInputMask_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/PhoneInputMask"));
var TextFieldValidator_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/TextFieldValidator"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_text_mask_1 = require("react-text-mask");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../config/constants"));
var validation_1 = __importStar(require("../../../config/validation"));
var actions_1 = require("../../../redux/reducers/profile/actions");
var Address_1 = __importDefault(require("../../../shared/components/input/Address"));
var ReloginModal_1 = __importDefault(require("./completeprofile/ReloginModal"));
var styles_1 = __importDefault(require("./styles"));
var validations_1 = require("./validations");
var ProfileScreen = function () {
    var _a;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var profile = (0, react_redux_1.useSelector)(function (state) { return state.profile; });
    var loading = profile.loading, userProfile = profile.userProfile;
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: {
            margin: theme.spacing(2, 0, 1, 2),
            color: colorsV2_1.default.palette.neutralsN700.hex()
        }
    };
    var _b = react_1.default.useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        address: new forms_1.Address(),
        apartmentNumber: '',
        phone: '',
        email: ''
    }), profileState = _b[0], setProfileState = _b[1];
    var _c = react_1.default.useState(false), formIsValid = _c[0], setFormIsValid = _c[1];
    var _d = react_1.default.useState(false), formIsDirty = _d[0], setFormIsDirty = _d[1];
    var _e = react_1.default.useState(false), showReloginModal = _e[0], setShowReloginModal = _e[1];
    var _f = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _f.isAuthenticated, isRestricted = _f.isRestricted;
    var phoneMaskedValue = '';
    if (((_a = profileState === null || profileState === void 0 ? void 0 : profileState.phone) === null || _a === void 0 ? void 0 : _a.toString().length) > 0) {
        phoneMaskedValue = (0, react_text_mask_1.conformToMask)(profileState.phone, validation_1.phoneMask, {}).conformedValue;
    }
    react_1.default.useEffect(function () {
        if (Object.keys(userProfile).length > 0) {
            updateProfileState();
        }
    }, [userProfile]);
    react_1.default.useEffect(function () {
        var firstName = profileState.firstName, lastName = profileState.lastName, dateOfBirth = profileState.dateOfBirth, phone = profileState.phone, address = profileState.address;
        var isValidForm = validations_1.profileSchema.isValidSync({
            firstName: firstName,
            lastName: lastName,
            dateOfBirth: dateOfBirth,
            phone: phone
        });
        var isValidAddress = (0, validations_1.addressSchema)(address.countryCode).isValidSync({
            address1: address.address1,
            city: address.city,
            zipCode: address.zipCode,
            country: address.country,
            state: address.state
        });
        setFormIsValid(isValidForm && isValidAddress);
        setFormIsDirty(true);
    }, [profileState]);
    var handleTextFieldChange = function (attr) { return function (event) {
        var value = event.target.value;
        setProfileState(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[attr] = value, _a)));
        });
    }; };
    var handleDateChange = function (date) {
        var dateOfBirth = (0, moment_1.default)(date).format('YYYY-MM-DD');
        setProfileState(function (prev) { return (__assign(__assign({}, prev), { dateOfBirth: dateOfBirth })); });
    };
    var formatDate = function (date) { return (date ? date.format('DD MMM YYYY') : ''); };
    var handleAddressSelect = function (newAddress) {
        setProfileState(function (prev) { return (__assign(__assign({}, prev), { address: __assign({}, newAddress) })); });
    };
    var updateProfileState = function () {
        var _a;
        var firstName = userProfile.firstName, lastName = userProfile.lastName, birthDate = userProfile.birthDate, addresses = userProfile.addresses, phones = userProfile.phones, email = userProfile.email;
        var homeAddress = addresses.filter(function (x) { return x.addressTypeId === types_1.AddressType.HOME; });
        var homePhone = phones
            .filter(function (p) { var _a, _b; return p.phoneTypeId === types_1.PhoneType.MOBILE && (((_b = (_a = p.phone) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0; })
            .sort(function (x, y) { return y.id - x.id; });
        var addressObject = homeAddress ? new forms_1.Address(homeAddress[0]) : new forms_1.Address();
        var apartmentNumber = (addressObject === null || addressObject === void 0 ? void 0 : addressObject.apartmentNumber) || '';
        setProfileState({
            firstName: firstName || '',
            lastName: lastName || '',
            dateOfBirth: birthDate ? (0, TimeUtil_1.utcDateTimeFor)(birthDate).format('DD MMM YYYY') : '',
            address: addressObject,
            phone: (_a = homePhone === null || homePhone === void 0 ? void 0 : homePhone[0]) === null || _a === void 0 ? void 0 : _a.phone,
            email: email,
            apartmentNumber: apartmentNumber
        });
    };
    var handleSubmit = function (event) {
        var _a;
        if (event) {
            event.preventDefault();
        }
        dispatch((0, actions_1.updateProfile)(__assign(__assign({}, profileState), { dateOfBirth: (0, TimeUtil_1.utcDateTimeFor)(profileState.dateOfBirth), phone: (_a = profileState.phone) === null || _a === void 0 ? void 0 : _a.replace(/\D+/g, '') })));
        var isRestrictionEnabled = isRestricted && isLoggedIn;
        if (isRestrictionEnabled) {
            setShowReloginModal(true);
        }
    };
    return (react_1.default.createElement("form", { onSubmit: handleSubmit, noValidate: true, "aria-labelledby": "profileHeading", style: { width: '100%' } },
        react_1.default.createElement("h2", { id: "profileHeading", style: { position: 'absolute', left: '-9999px' } }, "Profile Screen"),
        react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "space-between", spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6 },
                (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(core_1.Typography, { style: labelProps.labelStyle }, "First Name",
                    labelProps.isRequiredLabel ? ' *' : '')),
                react_1.default.createElement(TextFieldValidator_1.default, { required: true, id: "firstName", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'First Name' : null, name: "firstName", autoComplete: "given-name", className: classes.field, value: profileState.firstName, onChange: handleTextFieldChange('firstName'), validationSchema: validations_1.firstNameValidator, variant: constants_1.default.FIELDS_VARIANT, inputProps: {
                        maxLength: validation_1.default.maxNameLength,
                        'aria-required': true,
                        'aria-label': 'First Name'
                    } })),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, style: { marginTop: isMobile ? theme.spacing(-3) : 0 } },
                (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(core_1.Typography, { style: labelProps.labelStyle }, "Last Name",
                    labelProps.isRequiredLabel ? ' *' : '')),
                react_1.default.createElement(TextFieldValidator_1.default, { required: true, id: "lastName", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Last Name' : null, name: "lastName", autoComplete: "family-name", className: classes.field, value: profileState.lastName, onChange: handleTextFieldChange('lastName'), validationSchema: validations_1.lastNameValidator, variant: constants_1.default.FIELDS_VARIANT, inputProps: {
                        maxLength: validation_1.default.maxNameLength,
                        'aria-required': true,
                        'aria-label': 'Last Name'
                    } }))),
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
            (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(core_1.Typography, { style: labelProps.labelStyle }, "Date of Birth",
                labelProps.isRequiredLabel ? ' *' : '')),
            react_1.default.createElement(DateFieldValidator_1.default, { id: "dateOfBirth", required: true, label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Date of Birth' : null, name: "dateOfBirth", autoComplete: "bday", value: profileState.dateOfBirth, labelFunc: formatDate, onChange: handleDateChange, className: classes.field, validationSchema: validations_1.dateOfBirthValidator, minDate: validation_1.default.minDateOfBirth, maxDate: validation_1.default.maxDateOfBirth, maxDateMessage: "User must be 18 or older", error: !(0, moment_1.default)(profileState.dateOfBirth).isBetween(validation_1.default.minDateOfBirth, validation_1.default.maxDateOfBirth), inputVariant: constants_1.default.FIELDS_VARIANT, inputProps: {
                    'aria-label': 'Date of Birth'
                } }),
            react_1.default.createElement(Address_1.default, { address: profileState.address, handleAddressChange: handleAddressSelect, showMandatory: true, fieldVariant: constants_1.default.FIELDS_VARIANT || 'filled' }),
            (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(core_1.Typography, { style: labelProps.labelStyle }, "Phone Number",
                labelProps.isRequiredLabel ? ' *' : '')),
            react_1.default.createElement(TextFieldValidator_1.default, { id: "phone", required: true, label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Phone Number' : null, name: "phone", autoComplete: "tel", className: classes.field, value: phoneMaskedValue, onChange: handleTextFieldChange('phone'), InputProps: {
                    inputComponent: PhoneInputMask_1.default,
                    required: true,
                    type: 'tel'
                }, validationSchema: validations_1.phoneNumberValidator, variant: constants_1.default.FIELDS_VARIANT, inputProps: {
                    'aria-label': 'Phone Number'
                } }),
            react_1.default.createElement(core_1.Grid, { item: true, justifyContent: "center", className: classes.buttonWrap },
                react_1.default.createElement(core_1.Button, { size: "large", variant: "contained", color: "primary", className: classes.button, disabled: loading || !formIsValid || !formIsDirty, onClick: function () { return handleSubmit(); }, "aria-label": "Save Changes", type: "submit" }, "Save Changes")),
            react_1.default.createElement(ReloginModal_1.default, { show: showReloginModal }))));
};
exports.default = ProfileScreen;
//# sourceMappingURL=index.js.map